import { get } from 'lodash';
import React from 'react';
import { TreeNodeType } from '../../../../../lib/types/types';
import { assignIdsToStruc } from '../../../../../utils/helper';
import Abschluss from './content/Abschluss';
import Allgemein, { getFormStrucAllgemein } from './content/Allgemein';
import Antragsteller, { getFormStrucAntragsteller } from './content/Antragsteller';

import Bankdaten, { getFormStrucBankDaten } from './content/Bankdaten';
import Bescheid from './content/Bescheid';
import Bewerbungsdaten, { getFormStrucBewerbungsdaten } from './content/Bewerbungsdaten';

// import schemas
import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureFoerderAntrag = (application: any, _readOnly: boolean) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Allgemein',
			content: <Allgemein />,
			formStruc: getFormStrucAllgemein(),
		},
		{
			label: 'Bewerber*in',
			content: <Antragsteller />,
			formStruc: getFormStrucAntragsteller(),
		},
		{
			label: 'Bankdaten',
			content: <Bankdaten />,
			formStruc: getFormStrucBankDaten(),
		},
		{
			label: 'Bewerbungsdaten',
			content: <Bewerbungsdaten />,
			formStruc: getFormStrucBewerbungsdaten(),
		},
		{
			label: 'Abschluss',
			content: <Abschluss />,
		},
	];

	if (get(application, `${P.Bescheid_Bescheid.path}.id`)) {
		treeNodes.push({
			label: 'Bescheid',
			content: <Bescheid />,
		});
	}
	return assignIdsToStruc(treeNodes);
};
